import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { iniciales, norm } from "@/lib/format";
import { Loading, PageTitle, Empty } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";

export default function DocenteEstudiantes() {
  const [rows, setRows] = useState(null);
  const [materias, setMaterias] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    api.get("/estudiantes").then((r) => setRows(r.data)).catch(() => setRows([]));
    api.get("/docente/materias").then((r) => setMaterias(r.data));
  }, []);

  if (!rows) return <Loading />;

  const grados = [...new Set(materias.map((m) => m.grado))];
  const q = norm(busqueda.trim());
  const visibles = rows.filter(
    (e) =>
      (grados.length === 0 || grados.includes(e.grado)) &&
      (!q || [e.nombre, e.matricula, e.grado].filter(Boolean).some((v) => norm(v).includes(q)))
  );

  return (
    <div data-testid="docente-estudiantes">
      <PageTitle title="Mis estudiantes"
                 subtitle="Estudiantes de los grados en los que imparte materias." />

      <div className="relative mb-6 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="rounded-full pl-10" placeholder="Buscar por nombre o matrícula…"
               value={busqueda} onChange={(e) => setBusqueda(e.target.value)}
               data-testid="buscar-estudiante-docente" />
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="lista-estudiantes-docente">
        {visibles.map((e) => (
          <article key={e.id} className="lift rounded-lg border border-border/60 bg-card p-6">
            <div className="flex items-start gap-4">
              <div className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-primary/10 font-display font-bold text-primary">
                {iniciales(e.nombre)}
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-display text-base font-semibold">{e.nombre}</h3>
                <p className="font-mono text-xs text-muted-foreground">{e.matricula}</p>
              </div>
              <Badge variant="outline">{e.grado}</Badge>
            </div>
            <dl className="mt-5 space-y-2 text-sm">
              <div className="flex justify-between">
                <dt className="text-muted-foreground">Sección</dt><dd>{e.seccion || "—"}</dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-muted-foreground">Tutor</dt><dd>{e.tutor_nombre || "—"}</dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-muted-foreground">Alergias</dt><dd>{e.alergias || "—"}</dd>
              </div>
            </dl>
          </article>
        ))}
        {visibles.length === 0 && (
          <Empty testId="estudiantes-docente-vacios">
            {materias.length === 0
              ? "Aún no tiene materias asignadas, por eso no hay estudiantes que mostrar."
              : "Ningún estudiante coincide con la búsqueda."}
          </Empty>
        )}
      </div>
    </div>
  );
}
